<template>
  <div class="home">
    <app-head/>
    <router-view/>
    <app-foot/>
  </div>
</template>

<script>
import AppHead from '../components/common/AppHead'
import AppFoot from '../components/common/AppFoot'
import '../assets/css/common.styl'
import 'video.js/dist/video-js.css'
export default {
  name: 'home',
  components: {
    AppHead, AppFoot
  }
}
</script>
